import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  GetApiDocumentGetRequiredDocumentsQueryResponse,
  GetApiDocumentGetRequiredDocumentsQueryParams,
  GetApiDocumentGetRequiredDocuments401,
  GetApiDocumentGetRequiredDocuments403,
} from "../../../types/GetApiDocumentGetRequiredDocuments";

export function getGetApiDocumentGetRequiredDocumentsUrl() {
  return `/api/Document/get-required-documents` as const;
}

/**
 * {@link /api/Document/get-required-documents}
 */
export async function getApiDocumentGetRequiredDocuments(
  params?: GetApiDocumentGetRequiredDocumentsQueryParams,
  config: Partial<RequestConfig> & { client?: typeof client } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    GetApiDocumentGetRequiredDocumentsQueryResponse,
    ResponseErrorConfig<
      | GetApiDocumentGetRequiredDocuments401
      | GetApiDocumentGetRequiredDocuments403
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiDocumentGetRequiredDocumentsUrl().toString(),
    params,
    ...requestConfig,
  });
  return res;
}
